<template>
  <div class="liquor-area-list">
    <Header active="/liquor/country" />

    <SearchSelect :options.sync="options" @change="change" />

    <div class="country" v-for="(item, index) in countryList" :key="index" v-show="item.active">
      <div class="title">
        <div class="title-before"></div>
        <div class="title-after">{{item.country}}</div>
        <div class="title-more" @click="goto(`/liquor/country/${item.id}`)">
          查看国家详情
          <img src="/liquor/menu_arrow@2x.png" alt=">" />
        </div>
      </div>
      <div class="body">
        <div
          class="item"
          v-for="(item, index) in item.areaList"
          :key="index"
          @click="goto(`/liquor/area/${item.id}`)"
        >
          <div class="left">
            <img :src="util.getFirstImage(item.image, '180x180')" />
          </div>
          <div class="right">
            <div class="commodity-title">{{item.area}}</div>
            <div class="key-value">
              <div class="key">酒类级别评定：</div>
              <div class="value">{{item.level.split(' ').join('/')}}</div>
            </div>
            <div class="key-value">
              <div class="key">产区品牌：</div>
              <div class="value">{{item.brandList.map(e => e.brand).join('/')}}</div>
            </div>
            <div class="key-value">
              <div class="key">产区介绍：</div>
              <div class="value">{{item.intro}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Sticky />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import Sticky from "@/components/liquor/Sticky";
import MultiMedia from "@/components/liquor/MultiMedia";
import SearchSelect from "@/components/liquor/SearchSelect";

export default {
  name: "LiquorAreaList",
  components: {
    Header,
    Sticky,
    MultiMedia,
    SearchSelect
  },
  data() {
    return {
      areaList: [],
      brandList: [],
      countryList: [],
      options: [
        {
          level: 1,
          label: "国家",
          up: true,
          show: true,
          value: [
            {
              level: 1,
              label: "全部",
              value: "全部",
              active: true,
              type: "all"
            }
          ]
        }
      ]
    };
  },
  created() {
    this.init();
  },

  methods: {
    async init() {
      let response;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorArea",
        methodName: "retrieve",
        params: {
          numPerPage: 1000
        }
      });
      this.areaList = response.results;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorBrand",
        methodName: "retrieve",
        params: {
          numPerPage: 10000
        }
      });
      this.brandList = response.results;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCountry",
        methodName: "retrieve",
        params: {
          focus: true
        }
      });
      this.countryList = this.util.sortByPinyin(
        response.results.map(c => {
          return {
            ...c,
            active: true,
            areaList: this.util.sortByPinyin(
              this.areaList
                .filter(a => a.country === c.country)
                .map(a => {
                  return {
                    ...a,
                    brandList: this.brandList.filter(
                      b => b.country === c.country && b.area === a.area
                    )
                  };
                }),
              "area"
            )
          };
        }),
        "country"
      );

      this.options.find(e => e.label === "国家").value = [
        {
          label: "全部",
          value: "全部",
          level: 1,
          active: true,
          type: "all",
          show: true,
          parent: []
        },
        ...this.util.sortByPinyin(
          this.countryList.map(e => {
            return {
              label: e.country,
              value: e.country,
              level: 1,
              active: false,
              type: "tag",
              show: true,
              parent: []
            };
          }),
          "label"
        )
      ];

      console.log(this.countryList);
    },
    change() {
      this.countryList.map(c => {
        c.active =
          this.options[0].value.findIndex(
            e => e.value === c.country && e.active
          ) > 0;
      });

      console.log(this.options[0]);
      if (
        this.options[0].value.findIndex(e => e.active && e.type === "all") >= 0
      ) {
        this.countryList.map(c => {
          c.active = true;
        });
      }
    },
    goto(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
.liquor-area-list {
  margin-top: 110px;
  width: 100%;
  .country {
    width: 1100px;
    margin: 0 auto;

    .title {
      margin: 30px 0;
      height: 22px;
      font-size: 20px;

      font-weight: normal;
      color: rgba(59, 41, 9, 1);
      line-height: 22px;
    }

    .title-before {
      display: inline-block;
      margin-right: 10px;
      width: 6px;
      height: 12px;
      background: rgba(228, 200, 150, 1);
    }

    .title-after {
      font-family: "FZQKBYSJW";
      display: inline-block;
    }

    .title-more {
      float: right;
      cursor: pointer;
      text-align: center;
      width: 102px;
      height: 23px;
      border: 1px solid rgba(228, 200, 150, 1);
      font-size: 12px;
      font-weight: 400;
      color: rgba(194, 139, 43, 1);
      line-height: 23px;

      img {
        margin-left: 3px;
        width: 4px;
        height: 7px;
      }
    }

    .body {
      .item {
        width: 1060px;
        margin-bottom: 10px;
        padding: 20px;
        background: rgba(250, 250, 250, 1);
        cursor: pointer;

        .left {
          display: inline-block;
          vertical-align: top;
          width: 180px;
          height: 180px;
          margin-right: 20px;

          background: rgba(255, 255, 255, 0.9);

          img {
            width: 180px;
            height: 180px;
          }
        }

        .right {
          display: inline-block;
          vertical-align: top;
          .commodity-title {
            max-width: 858px;
            // height: 25px;
            font-size: 18px;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            line-height: 25px;

            margin-bottom: 25px;
          }

          .key-value {
            margin-bottom: 10px;
            .key {
              display: inline-block;
              vertical-align: top;
              width: 120px;
              height: 20px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(132, 135, 145, 1);
              line-height: 20px;
            }

            .value {
              display: inline-block;
              vertical-align: top;
              max-width: 738px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
            }
          }
        }
      }

      .item:hover {
        background: rgba(255, 248, 235, 1);
      }
    }
  }
}
</style>